import { type FC } from 'react';

import { SnackbarProvider as RootSnackbarProvider } from 'notistack';

import { SnackbarAlert } from '@craft/ui/components/alerts';

interface SnackbarProviderProps {
  readonly children: React.ReactNode;
}

/**
 * Wraps the notistack {@link RootSnackbarProvider} to provide configuration.
 *
 * @see https://mui.com/material-ui/react-snackbar/#notistack
 * @see https://github.com/iamhosseindhv/notistack
 */
export const SnackbarProvider: FC<SnackbarProviderProps> = ({ children }) => (
  <RootSnackbarProvider
    Components={{
      default: SnackbarAlert,
      error: SnackbarAlert,
      info: SnackbarAlert,
      success: SnackbarAlert,
      warning: SnackbarAlert,
    }}
    disableWindowBlurListener
    maxSnack={1}
    preventDuplicate
  >
    {children}
  </RootSnackbarProvider>
);
